export function formatTrialEndDate(iso, locale) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString(locale || undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch (_) {
    return String(iso);
  }
}

/** Relative urgency + absolute end date for plan subscription cards. */
export function formatPlanTrialMeta(iso, t, locale, nowMs = Date.now()) {
  const date = formatTrialEndDate(iso, locale);
  if (!date) return "";
  const endMs = new Date(iso).getTime();
  if (Number.isNaN(endMs)) {
    return t("settings.plan_trial_ends", {
      date,
      defaultValue: "Trial ends {{date}}",
    });
  }
  const hoursLeft = Math.max(0, endMs - nowMs) / (1000 * 60 * 60);
  let remaining;
  if (hoursLeft <= 24) {
    if (hoursLeft <= 0) {
      remaining = t("settings.plan_trial_ends_today", {
        defaultValue: "Ends today",
      });
    } else {
      const h = Math.max(1, Math.ceil(hoursLeft));
      remaining = t("settings.plan_trial_hours_left", {
        count: h,
        defaultValue: "{{count}} hours left",
      });
    }
  } else {
    const d = Math.max(1, Math.ceil(hoursLeft / 24));
    remaining =
      d === 1
        ? t("settings.plan_trial_day_left", { defaultValue: "1 day left" })
        : t("settings.plan_trial_days_left", {
            count: d,
            defaultValue: "{{count}} days left",
          });
  }
  return t("settings.plan_trial_meta", {
    remaining,
    date,
    defaultValue: "{{remaining}} · ends {{date}}",
  });
}
